/** Quick-fill purposes under the Giveaway form's Purpose field. */
export const CAMPAIGNS = [
  'Christmas Celebration',
  'Trading Competition',
  'Influencer Campaign',
  'Discord Giveaway',
  'Community Rewards',
];
